module.exports = {
    "oh_url": "https://ophubuat.litedev.com",
    "pro_url": "https://ophubuat.litedev.com/pro2",
    "com_url": "https://chubuat.litedev.com",
    "family_url":"https://fhubuat.litedev.com/pro",
    "socket_url": "https://socketuat.litedev.com",
    "chs_url": "https://chsv3.sanar.sa",
    "lab_url": "https://labuat.litedev.com",
    "nurse_url": "https://nurseuat.litedev.com",
    "version": "0.0.1",
    "auth_url": "https://authuat.litedev.com/"
    /* "oh_url": "http://localhost:4003",
    "pro_url": "http://localhost:4003/pro2",
    "com_url": "http://localhost:7001" */
}